import { gql } from '@apollo/client';

export const GET_ANNUAL_REPORTS = gql`
  query GET_ANNUAL_REPORTS(
    $ids: [ID!]
    $reportingPeriods: [ID!]
    $faculty: ID
    $projectCategory: ID
  ) {
    annualReports(
      ids: $ids
      reportingPeriods: $reportingPeriods
      faculty: $faculty
      projectCategory: $projectCategory
    ) {
      id
      reportingPeriod {
        id
        startDate
        endDate
        scheduledDeadline
      }
      faculty {
        id
        name
        abbreviation
      }
      projectCategory {
        id
        name
      }
      attachment {
        id
        filename
      }
      actualSubmissionDate
      remarks
      disabled
      deleted
    }
  }
`;

export const ADD_ANNUAL_REPORT = gql`
  mutation ADD_ANNUAL_REPORT($input: AddAnnualReportInput!) {
    addAnnualReport(input: $input) {
      id
    }
  }
`;

export const ADD_ANNUAL_REPORT_WITH_CUSTOM_DATE = gql`
  mutation ADD_ANNUAL_REPORT_WITH_CUSTOM_DATE(
    $input: AddAnnualReportWithCustomDateInput!
  ) {
    addAnnualReportWithCustomDate(input: $input) {
      id
    }
  }
`;

export const UPDATE_ANNUAL_REPORT = gql`
  mutation UPDATE_ANNUAL_REPORT($input: UpdateAnnualReportInput!) {
    updateAnnualReport(input: $input) {
      id
    }
  }
`;

export const UPDATE_ANNUAL_REPORT_WITH_CUSTOM_DATE = gql`
  mutation UPDATE_ANNUAL_REPORT_WITH_CUSTOM_DATE(
    $input: UpdateAnnualReportWithCustomDateInput!
  ) {
    updateAnnualReportWithCustomDate(input: $input) {
      id
    }
  }
`;

export const DELETE_ANNUAL_REPORT = gql`
  mutation DELETE_ANNUAL_REPORT($id: ID!) {
    deleteAnnualReport(id: $id) {
      id
      deleted
      disabled
    }
  }
`;
